// Compact language toggle for the AlveeFx Clip Program UI.
// Toggles between English and বাংলা. State managed by useI18n().

import { useI18n } from '../lib/i18n';
import { Globe } from 'lucide-react';

export function LanguageToggle({ className = '' }) {
  const { lang, setLang } = useI18n();
  const isBn = lang === 'bn';

  return (
    <button
      type="button"
      onClick={() => setLang(isBn ? 'en' : 'bn')}
      data-testid="lang-toggle"
      aria-label={isBn ? 'Switch to English' : 'বাংলায় দেখুন'}
      className={
        'inline-flex items-center gap-1.5 h-8 px-3 rounded-full border border-white/10 ' +
        'bg-white/[0.02] hover:bg-white/[0.06] hover:border-white/20 transition-colors ' +
        'text-[11px] uppercase tracking-[0.18em] font-semibold text-white/80 ' +
        className
      }
    >
      <Globe className="h-3.5 w-3.5 text-[hsl(43_92%_72%)]" />
      {isBn ? (
        <span className="normal-case tracking-normal">বাংলা</span>
      ) : (
        <span>EN</span>
      )}
    </button>
  );
}
